module.exports = __webpack_public_path__ + "static/media/rebate.bc577e61.wav";